// organize-imports-ignore
import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput';
import { StringDateAdapter } from 'vuetify/date/adapters/string';
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // use @mdi/font
// import { aliases, mdi } from 'vuetify/iconsets/mdi-svg' // use @mdi/js
import { md2 } from 'vuetify/blueprints';
import '@mdi/font/css/materialdesignicons.css';

// Apply SaaS variables override to Core Vuetify's CSS,
// using `resources/styles/vuetify.scss` (configured in `vite.config.js`)
import 'vuetify/styles';

/* SCSS controls appearance and style defaults; JS handles icon sets and behavior */
import defaults from './defaultsStyle.js';
import theme from './theme.js';

const vuetifyLabsComponents = {
  VDateInput,
};

export default createVuetify({
  theme,
  defaults,
  blueprint: md2,
  components: vuetifyLabsComponents,
  date: {
    adapter: StringDateAdapter, // This forces ISO strings (YYYY-MM-DD) instead of native Date object for `v-date-input` component
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      // Add any custom aliases here
    },
    sets: {
      mdi,
    },
  },
});
